import { PathStopAPI } from '../../../api/bussched/PathStopAPI';

export class PathStopsCommand {
    listStops(edition, line, successCallback, errorCallback) {
        const apiResult = PathStopAPI.listStops(edition, line);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as Paragens da Linha selecionada");
            }
        });
    }

    listComplementaryStops(edition, lines, successCallback, errorCallback) {
        const apiResult = PathStopAPI.listComplementaryStops(edition, lines);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as Paragens das Linhas Complementares selecionadas");
            }
        });
    }

    listLines(edition, stop, successCallback, errorCallback) {
        const apiResult = PathStopAPI.listLines(edition, stop);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as Linhas da Paragem selecionada");
            }
        });
    }
}
